import React, { memo } from 'react';
import { styled } from '@mui/material/styles';
import Snackbar from '@mui/material/Snackbar';
import SnackbarContent from '@mui/material/SnackbarContent';
import { Colors } from 'modules/theme';
import { Icon } from 'modules/ui';
import classes from './Notification.module.scss';

const PREFIX = 'Notification';

const rootClasses = {
  root: `${PREFIX}-root`,
};

const StyledSnackbar = styled(Snackbar)({
  [`& .${rootClasses.root}`]: {
    display: 'flex',
    justifyContent: 'center',
    textAlign: 'center',
    minWidth: '463px',
    maxWidth: '70%',
    minHeight: '60px',
    cursor: 'pointer',
    borderRadius: '8px',
    // TODO fix this for IE 11 flex bug https://stackoverflow.com/a/51218681/9801221 be careful of this messing up in other browser when the message is longer
  },
});

const StyledSnackbarContent = SnackbarContent;

const styles = {
  success: {
    backgroundColor: Colors.darkGrey,
    color: 'white',
  },
  warning: {
    backgroundColor: Colors.warning,
    color: 'black',
  },
  error: {
    backgroundColor: Colors.error,
    color: 'white',
  },
};

function Notification({
  notification,
  onClose,
  anchorOrigin = {
    vertical: 'bottom',
    horizontal: 'center',
  },
  duration = 5000,
}) {
  if (notification === null) {
    return;
  }

  const { message, type } = notification;

  const ActionIcon = (
    <Icon
      name={type}
      color={styles[type].color}
      size={26}
      className={classes.icon}
    />
  );

  return (
    <StyledSnackbar
      open={!!message}
      onClose={onClose}
      anchorOrigin={anchorOrigin}
      autoHideDuration={duration}
      key={message}
      onClick={onClose}
      ClickAwayListenerProps={{ onClickAway: () => null }}
    >
      <StyledSnackbarContent
        style={styles[type]}
        message={
          <div className={classes.message}>
            {ActionIcon}
            {message}
          </div>
        }
        classes={{
          root: classes.root,
        }}
      />
    </StyledSnackbar>
  );
}

export default memo(Notification);
